import React from "react";
import ReactDOM from "react-dom";
import CircularProgress from "@mui/material/CircularProgress";

const PageLoader = () => {
  return (
    <div className="backdrop">
      {ReactDOM.createPortal(
        <div className="circular-progress">
          <CircularProgress
            size={50}
            sx={(theme) => ({
              color: "#084f0b",
            })}
          />
        </div>,
        document.getElementById("loader-root")
      )}
    </div>
  );
};

export default PageLoader;
